module.exports = __webpack_public_path__ + "img/top_miryoku.13c57bdb.gif";